<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    :editTitle="editTitle"
    :readTitle="readTitle"
    :editIcon="editIcon"
    :readOnly="readOnly"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :isTextButton="isTextButton"
    :textButton="textButton"
    buttonColor="success"
    editSaveButtonLabel="Confirmar Recebimento"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        id="printableELement"
        :paymentConfirmation="true"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null,
      partialReadOnly: false
    };
  },
  props: {
    entry: Object,
    editTitle: {
      type: String,
      default: "Confirmação de Recebimento de Parcela"
    },
    readTitle: {
      type: String,
      default: "Visualização de Recebimento de Parcela"
    },
    editIcon: {
      type: String,
      default: "mdi-check" //mdi-cash-check
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    // partialReadOnly: {
    //   type: Boolean,
    //   default: false
    // },
    isTextButton: {
      type: Boolean,
      default: false
    },
    textButton: {
      type: String,
    }
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit,
    BasePrint: BasePrint
  },
  created() {
  },
  methods: {
    loadServerEntry: function(id) {
      // console.log(id);
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_CASH_INFLOW_INSTALLMENT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.cashInflowInstallment;
          this.extraData = response.data;
          // if (this.editableEntry.canBeDeleted === false) {
          //   this.partialReadOnly = true;
          // }
          // console.log("cashInflowInstallment edit", this.editableEntry);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    payInstallmentEntirely: function(installment) {
      // console.log("pagamento integral", installment)
      // console.log("installment", installment, installment.fullPaymentValidations, this.deepFilterEntryWithAllowedFieldsForMutation(installment, installment.fullPaymentValidations));

      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: PAY_INSTALLMENT_ENTIRELY_MUTATION,
          variables: {
            id: installment.id,
            input: this.deepFilterEntryWithAllowedFieldsForMutation(installment, installment.fullPaymentValidations)
          }
        })
        .then(response => {
          var errors = response.data.payInstallmentEntirely.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated", response.data.payInstallmentEntirely.installment);
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    payInstallmentPartially: function(installment) {
      // console.log("pagamento parcial", installment)
      // console.log("installment", installment, installment.partialPaymentValidations, this.deepFilterEntryWithAllowedFieldsForMutation(installment, installment.partialPaymentValidations));

      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: PAY_INSTALLMENT_PARTIALLY_MUTATION,
          variables: {
            id: installment.id,
            input: this.deepFilterEntryWithAllowedFieldsForMutation(installment, installment.partialPaymentValidations)
          }
        })
        .then(response => {
          var errors = response.data.payInstallmentPartially.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated", response.data.payInstallmentPartially.installment);
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        if (this.editableEntry.originalValue == this.editableEntry.paidAmount) {
          this.payInstallmentEntirely(this.editableEntry);
        } else {
          this.payInstallmentPartially(this.editableEntry);
        }

      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
      this.$emit("entry-canceled");
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_CASH_INFLOW_INSTALLMENT_QUERY = gql `
  query ($id: ID!) {
  globalContext{
    allGlobalPaymentMethods{
      id
      name
    }
  }
  accountContext {
    cashInflowInstallment(id: $id){
      id
      code
      payment {
        cashFlow {
          chart {
            name
          }
          customer {
            name
          }
        }
      }
      dueDate
      paymentDate
      paymentMethod {
        id
        name
      }
      bankAccountId
      bankAccount {
        id
        name
        nameWithBank
        currentBalance
        accountNumber
        agencyNumber
        bankAccountType {
          id
          name
        }
        bank {
          id
          name
          nameWithCode
        }
      }
      originalValue
      value
      interest
      penalty
      discount
      paidAmount
      totalPaidAmount
      isFullyPaid
      isPartiallyPaid
      additionalPaymentsAttributes {
        id
        code
        bankAccountId
        paymentMethodId
        value
        initialDate
        installmentsIntervalId
        installmentsInterval {
          id
          description
          intervalInDays
        }
        paymentConditionId
        paymentCondition {
          id
          description
          numberOfInstallments
        }
        paymentMethod {
          id
          name
        }
        bankAccount {
          id
          name
        }
        installmentsAttributes {
          id
          value
          originalValue
          customCode
          dueDate
          code
          status
          statusKey
          statusColor
          paidAmount
          totalPaidAmount
          paymentDate
          bankAccount {
            id
            name
          }
        }
      }
      observation
      parentObservation
      fullPaymentValidations
      partialPaymentValidations
    }
    allBankAccountsForInstallment(installmentId: $id) {
      id
      name
      nameWithBank
      currentBalance
      accountNumber
      agencyNumber
      bankAccountType {
        id
        name
      }
      bank {
        id
        name
        nameWithCode
      }
    }
  }
}
`;

const PAY_INSTALLMENT_ENTIRELY_MUTATION = gql `
  mutation($id: ID!, $input: InstallmentFullPaymentInputObject!) {
    payInstallmentEntirely(id: $id, input: $input) {
      installment {
        id
        originalValue
        customCode
        dueDate
        code
        status
        statusKey
        statusColor
        paidAmount
        totalPaidAmount
        paymentDate
      }
      errors
    }
  }
`;

const PAY_INSTALLMENT_PARTIALLY_MUTATION = gql `
  mutation($id: ID!, $input: InstallmentPartialPaymentInputObject!) {
    payInstallmentPartially(id: $id, input: $input) {
      installment {
        id
        originalValue
        customCode
        dueDate
        code
        status
        statusKey
        statusColor
        paidAmount
        totalPaidAmount
        paymentDate
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
